/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignWorkersAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/workers', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ role, city } = {}) {
    const params = {};
    if (role) params.role = role;
    if (city) params.city = city;
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  import(file) {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${this.url}/import`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new ElectoralCampaignWorkersAPI();
